import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "IRC", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MDBIcon = _resolveComponent("MDBIcon")!
  const _component_MDBBtn = _resolveComponent("MDBBtn")!
  const _component_MDBBtnGroup = _resolveComponent("MDBBtnGroup")!

  return (_openBlock(), _createBlock(_component_MDBBtnGroup, {
    vertical: "",
    class: "flex-column position-fixed align-self-center",
    "aria-label": "Vertical social media bar"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_MDBBtn, {
        title: "twitter",
        href: "#",
        class: "twitter text-light",
        color: "primary"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_MDBIcon, {
            size: "2x",
            icon: "twitter",
            iconStyle: "fab"
          })
        ]),
        _: 1
      }),
      _createVNode(_component_MDBBtn, {
        title: "telegram",
        href: "#",
        class: "telegram text-light",
        color: "info"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_MDBIcon, {
            size: "2x",
            icon: "telegram",
            iconStyle: "fab"
          })
        ]),
        _: 1
      }),
      _createVNode(_component_MDBBtn, {
        title: "irc",
        href: "#",
        size: "2x",
        class: "irc",
        color: "dark"
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createVNode(_component_MDBIcon, {
            icon: "hashtag",
            iconStyle: "fas"
          })
        ]),
        _: 1
      }),
      _createVNode(_component_MDBBtn, {
        title: "twitch",
        href: "#",
        class: "twitch text-gray-100",
        color: "secondary"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_MDBIcon, {
            size: "2x",
            icon: "twitch",
            iconStyle: "fab"
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}